import { render, staticRenderFns } from "./HtmlSelectOption.vue?vue&type=template&id=972b4798&"
import script from "./HtmlSelectOption.vue?vue&type=script&lang=ts&"
export * from "./HtmlSelectOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports